import { $admin } from "./api/admin";
import apiEndpoints from "@/constants/api-endpoints";

// Define all the accounts api services in this file

/**
 * Fetches accounts from the api resource
 * @param {Object} params - Api params
 * @returns {Promise} APi response
 */
export const getAccounts = (params) => {
  return $admin.get(apiEndpoints.accounts, { params });
};

/**
 * Fetches email address seeds from the api resource
 * @param {Object} params - Api params
 * @returns {Promise} APi response
 */
export const getSeeds = (params) => {
  return $admin.get(apiEndpoints.seeds, { params });
};

/**
 * Sends a post request to create a new account
 * @param {Object} params - Api params new account details
 * @returns {Promise} API response
 */
export const createAccount = (params) => {
  return $admin.post(apiEndpoints.accounts, params);
};

/**
 * Fetches account details from the api resource
 * @param {Object} params - Api request params
 * @returns {Promise} Api response account details
 */
export const getAccount = ({ account_id, ...params }) => {
  const endpoint = `${apiEndpoints.accounts}/${account_id}`;
  return $admin.get(endpoint, { params });
};

/**
 * Sends a post request to update account
 * @param {Object} params - Api params account details
 * @returns {Promise} API response
 */
export const updateAccount = ({ account_id, ...params }) => {
  const endpoint = `${apiEndpoints.accounts}/${account_id}`;
  return $admin.put(endpoint, params);
};

/**
 * Fetches list of users associated with an account
 * @param {Object} params - Api params for sorting and pagination
 * @returns {Promise} API response
 */
export const getAccountUsers = (accountId, params) => {
  const endpoint = `${apiEndpoints.accounts}/${accountId}${apiEndpoints.users}`;
  return $admin.get(endpoint, { params });
};

/**
 * Fetches 6 months inbox placement usage of an account
 * @param {String} accountId Id of an account whose usage is to be fetched
 * @returns {Promise}
 */
export const getAccountUsage = (accountId, params = null) => {
  return $admin.get(`${apiEndpoints.accounts}/${accountId}/usage`, { params });
};

/**
 * Update bulk users role for an account
 * * @param {String} accountId id of an account whose users role have to be updated
 * @param {Object} payload list of users and their role whichs are to be update
 * @returns {Promise}
 */
export const updateAccountUsers = (accountId, payload) => {
  return $admin.put(
    `${apiEndpoints.accounts}/${accountId}/update_users`,
    payload
  );
};

/**
 * Deletes bulk users access from an account
 * @param {String} accountId id of an account whose users are to be deleted
 * @param {Object} payload list of users whose access for an account have to removed
 * @returns {Promise}
 */
export const deleteAccountUsers = (accountId, usersId) => {
  return $admin.delete(`${apiEndpoints.accounts}/${accountId}/delete_users`, {
    data: usersId,
  });
};
